<template>
  <v-container class="teacher-list" v-if="ready">
    <v-row justify="space-between" class="my-3">
      <v-col cols="12" md="6">
        <h1 class="mt-2 header-title optus-highlight optus-highlight--yellow">
          All my classes&nbsp;
        </h1>
      </v-col>
      <v-col cols="12" md="3">
        <!-- <v-fade-transition>
          <div class="text-md-right text-center sm:mt-4">
            <v-btn v-if="classList.length" @click="toggleCreate">
              <v-icon left>
                {{ newClass ? 'close' : 'group_add' }}
              </v-icon>
              {{ newClass ? 'Cancel' : 'New class Code' }}
            </v-btn>
          </div>
        </v-fade-transition> -->
      </v-col>
    </v-row>
    <v-slide-y-transition>
      <p v-if="!activeClass.length">
        <v-icon left>info</v-icon>You are not enrolled into any class
      </p>
      <add-new-class-code
        v-if="
          classList && (newClass || !classList.length || !activeClass.length)
        "
        @classAccepted="classAccepted"
      />
    </v-slide-y-transition>
    <!-- <class-item-student
      v-for="(item, index) in classList"
      :key="'my-class-' + index"
      :customClass="item"
      :is-expandable="!newClass"
      @expand="closeOtherPanels(index)"
    /> -->
    <class-item-student
      v-for="(item, index) in activeClass"
      :key="'active-class-' + index"
      ref="class"
      :customClass="item"
      :is-expandable="!newClass"
      @expand="closeOtherPanels(index)"
    />
    <v-subheader v-if="inactiveClass.length" class="pl-0 title">
      Inactive classes
    </v-subheader>
    <v-divider v-if="inactiveClass.length" class="pb-3" />
    <class-item-student
      v-for="(item, index) in inactiveClass"
      :key="'inactive-class-' + index"
      :customClass="item"
      :is-expandable="!newClass"
      @expand="closeOtherPanels(index)"
    />
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import AddNewClassCode from './AddNewClassCode'
import ClassItemStudent from './ClassItemStudent'
import Class from '@/modules/class/models/Class'
import { setTimeout } from 'timers'

export default {
  name: 'ClassList',
  components: {
    AddNewClassCode,
    ClassItemStudent
  },
  data() {
    return {
      newClass: false,
      activeIndex: -1,
      ready: false
    }
  },
  computed: {
    classList() {
      const classes = this.$store.getters['entities/classes/query']()
        .orderBy('created_at', 'desc')
        .get()

      return classes
    },
    activeClass() {
      return this.classList.filter(classItem => {
        return !classItem.class_invitation_deleted
      })
    },
    inactiveClass() {
      return this.classList.filter(classItem => {
        return classItem.class_invitation_deleted
      })
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Class.dispatch('fetchForStudent')
    // await ClassItemStudent.dispatch('fetch')
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })

    let query = this.$route.query
    if (query.create) {
      this.newClass = true
    } else if (query.currentClassId) {
      this.$store.commit(
        'entities/classes/setCurrentClassId',
        query.currentClassId
      )

      setTimeout(() => {
        if (!this.$refs.class) return
        let comp = this.$refs.class.find(
          c => c.customClass.id === query.currentClassId
        )
        // comp.setActive('add-new-students')
        this.$scrollTo(comp.$el, 500, { offset: -80 })
      }, 300)
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    closeOtherPanels(index) {
      this.newClass = false
      this.activeIndex = index
    },
    classAccepted() {
      setTimeout(() => {
        this.newClass = false
        this.deselectAllLesson()
        // this.$nextTick(() => {
        //   let comp = this.$refs.class.find(
        //     c => c.customClass.id === customClass.id
        //   )
        //   comp.setActive('add-new-students')
        //   this.$scrollTo(comp.$el, 500, { offset: -80 })
        //   this.setQuery(this.newClass, customClass.id, 'student', '1')
        // })
      }, 1000)
    },
    toggleCreate() {
      this.newClass = !this.newClass
      this.setQuery(this.newClass)
    },
    setQuery(isCreate, classId, parentTab) {
      let query = Object.assign({}, this.$route.query)
      if (isCreate) {
        query.create = 'true'
        delete query.currentClassId
        delete query.currentParentTab
      } else {
        delete query.create

        if (classId) {
          query.currentClassId = classId
          query.currentParentTab = parentTab
        }
      }
      this.$router.push({ query: query })
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-list {
  .header {
    padding-left: 41px !important;
    padding-right: 41px !important;
  }
}
.pull-right {
  text-align: right;
}
</style>
